<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>基础信息</el-breadcrumb-item>
            <el-breadcrumb-item>商品类型维护</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card style="height: 600px;">
            <div>>> <span class="title">大类01</span>><span class="title">大类02</span>><span class="title">大类03</span>><span
                    class="title">小类</span></div>
            <el-cascader-panel ref="refCascader" :options="productTypeSlectOption" :value="chengxingUidSelected"
                height="200" @change="change(chengxingUidSelected)" filterable style="padding-left: 70px; "
                :props="{ multiple: false, checkStrictly: true }"></el-cascader-panel>
            <el-form ref="editFormRef" :model="editForm" :rules="editFormRules" label-width="100px"
                style=" margin-top: 20px;">
                <el-form-item label="输入项" prop="yuangong_bianhao">
                    <div class="xiugai" style="width: 850px;">
                        <div>
                            <div>
                                <el-input v-model="editForm.product_type01" :disabled="true"
                                    style="width: 190px;"></el-input>
                            </div>
                            <div>
                                <el-button type="primary" @click="productType_update(1, 1)" v-if="true"
                                     :disabled="true">增</el-button>
                                <el-button type="primary" @click="productType_update(1, 2)" v-if="true"
                                    :disabled="true">删</el-button>
                                <el-button type="primary" @click="productType_update(1, 3)" v-if="true"
                                    :disabled="true">改</el-button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-input v-model="editForm.product_type02" :disabled="!(editFormControl  == 2 || editFormControl  == 3) "
                                    style="width: 190px;"></el-input>
                            </div>
                            <div>
                                <el-button type="primary" @click="productType_update(2, 1)" v-if="true"
                                    :disabled="editFormControl !== 2">增</el-button>
                                <el-button type="primary" @click="productType_update(2, 2)" v-if="true"
                                    :disabled="editFormControl !== 3">删</el-button>
                                <el-button type="primary" @click="productType_update(2, 3)" v-if="true"
                                    :disabled="editFormControl !== 3">改</el-button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-input v-model="editForm.product_type03" :disabled="editFormControl !== 3"
                                    style="width: 190px;"></el-input>
                            </div>
                            <div>
                                <el-button type="primary" @click="productType_update(3, 1)" v-if="true"
                                    :disabled="editFormControl !== 3">增</el-button>
                                <el-button type="primary" @click="productType_update(3, 2)" v-if="true"
                                    :disabled="editFormControl !== 4">删</el-button>
                                <el-button type="primary" @click="productType_update(3, 3)" v-if="true"
                                    :disabled="editFormControl !== 4">改</el-button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-input v-model="editForm.product_type04" :disabled="editFormControl !== 4"
                                    style="width: 190px;"></el-input>
                            </div>
                            <div>
                                <el-button type="primary" @click="productType_update(4, 1)" v-if="true"
                                    :disabled="editFormControl !== 4">增</el-button>
                                <el-button type="primary" @click="productType_update(4, 2)" v-if="true"
                                    :disabled="editFormControl !== 5">删</el-button>
                                <el-button type="primary" @click="productType_update(4, 3)" v-if="true"
                                    :disabled="editFormControl !== 5">改</el-button>
                            </div>
                        </div>
                    </div>
                </el-form-item>

            </el-form>
        </el-card>
    </div>
</template>
<script>
// import cheXingSelect from './cheXing_select.vue';
export default {
    components: {
        //  cheXingSelect: cheXingSelect
    },
    data() {
        return {
            editForm: {
                type01_uid: 0,
                type02_uid: 0,
                type03_uid: 0,
                type04_uid: 0,
                product_type01: '',
                product_type02: '',
                product_type03: '',
                product_type04: ''
            },
            editFormControl: 1,
            chengxingUidSelected: 0,
            // 删除按钮是否可见
            // 获取商品类型列表参数
            productTypeList: [],
            // 用于下拉框的数据读取

            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            add_isDisable: false,
            //  添加表单数据项
            addForm: {
                C_type: 'productType_add',
                product_changjia: '',
                product_xinghao: '',
                product_xilie: '',
                product_year: '',
                product_port_count: '',
                product_leibie: ''

            },
            productTypeSlectOption: [],
            addFormRules: {

            },
            editFormRules: {}
        };
    },
    created() {
        this.productTypeSelect_list();
    },
    methods: {

        async productType_update(type, caozuoType) {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return this.$message.error('验证错误！');
                // 对象加入一个项C_type
                const { data: res } = await this.$http.post('api', {
                    C_type: 'productType_update',
                    type01_uid: this.editForm.type01_uid,
                    type02_uid: this.editForm.type02_uid,
                    type03_uid: this.editForm.type03_uid,
                    type04_uid: this.editForm.type04_uid,
                    product_type01: this.editForm.product_type01,
                    product_type02: this.editForm.product_type02,
                    product_type03: this.editForm.product_type03,
                    product_type04: this.editForm.product_type04,
                    type: type,
                    caozuoType: caozuoType
                });
                // if (JSON.parse(res.data)[0].status === 301) {
                //     this.$message.error('有下级类型，无法删除！')
                //     return;
                // }
                if (JSON.parse(res.data)[0].status !== 200) {
                    this.$message.error(JSON.parse(res.data)[0].msg)
                    return;
                }
                this.$message.success('更新成功')
                this.productTypeSelect_list()
                // this.editFormControl = 1
            });
        },
        change(data) {
            const areaTextArr = []
            const areaTextArr2 = []
            const arr = this.$refs.refCascader.getCheckedNodes()[0].pathNodes;
            this.editForm.type01_uid = arr.length === 1 ? arr[0].value : 0
            this.editForm.type02_uid = arr.length === 2 ? arr[1].value : 0
            this.editForm.type03_uid = arr.length === 3 ? arr[2].value : 0
            this.editForm.type04_uid = arr.length === 4 ? arr[3].value : 0
            this.editForm.product_type01 = arr.length === 1 ? arr[0].label : ''
            this.editForm.product_type02 = arr.length === 2 ? arr[1].label : ''
            this.editForm.product_type03 = arr.length === 3 ? arr[2].label : ''
            this.editForm.product_type04 = arr.length === 4 ? arr[3].label : ''
            // arr.length 为选中的类型是几级
            this.editFormControl = arr.length + 1 // 控制输入框是否锁定
            console.log('881', arr, this.editFormControl)
            // this.$emit('getCarTypeSelectedUid', this.productTypeSelectedUid)
        },
        async productTypeSelect_list() {
            const { data: res } = await this.$http.get('get_api', {
                params: {
                    C_type: 'productTypeSelect_list',
                    type: 1
                }
            });
            console.log(776, JSON.parse(res.data)[0])
            this.productTypeSlectOption = JSON.parse(res.data)[0].data
        },
        addproductType() {
            // this.$refs.addFormRef.validate(async valid => {
            //     if (!valid) return 1;
            //     this.add_isDisable = true
            //     setTimeout(() => {
            //         this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
            //     }, 2000)

            //     const { data: res } = await this.$http.post('api', this.addForm);
            //     console.log(JSON.parse(res.data)[0].status);
            //     if (JSON.parse(res.data)[0].status === 202) {
            //         this.$message.error('商品类型名重复，添加失败');
            //         return;
            //     }
            //     if (JSON.parse(res.data)[0].status !== 200) {
            //         this.$message.error('添加失败');
            //         return;
            //     }
            //     this.$message.success('添加成功');
            //     this.getproductTypeList();
            //     this.addDialogVisible = false;
            // });
        },
        showEditDialog(uid) {
            this.editDialogVisible = true;
            this.productTypeInfo(uid);
        },
        editDoalogClosed() {
            this.$refs.editFormRef.resetFields();
        },
        async productTypeInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'productType_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
        },

        // 删除一条记录
        async deleteForm(productTypeUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'productType_del',
                C_data1: productTypeUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getproductTypeList();
        },
        add_product_port_count() {
            this.addForm.product_port_count = this.addForm.product_port_count.replace(/[^\d.]/g, '')
        },
        update_product_port_count() {
            this.editForm.product_port_count = this.editForm.product_port_count.replace(/[^\d.]/g, '')
        }
    }
};
</script>
<style lang="less" scoped>
.productd_two {
    margin-top: 30px;
    box-shadow: none !important;
}

.el_row_two {
    margin-top: 30px;
}

.xiugai {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.el-cascader__item {
    height: 500px;
}

.title {
    font-size: 14px;
    font-weight: 400;
    width: 200px;

}</style>
